/* UI adapter only: Sufio's generated Save button owns all validation requests. */
(() => {
  if (window.SlimCartVAT) return;
  const storageKey = 'slim-cart-vat';
  let current;

  function remember(pair) {
    try {
      if (pair) sessionStorage.setItem(storageKey, JSON.stringify(pair));
      else sessionStorage.removeItem(storageKey);
    } catch (_) { /* The form also works when browser storage is unavailable. */ }
  }

  function restore(customerEmail) {
    try {
      const pair = JSON.parse(sessionStorage.getItem(storageKey));
      if (typeof pair?.email === 'string' && typeof pair?.vat === 'string' &&
          (!customerEmail || pair.email === customerEmail)) return pair;
    } catch (_) { /* Ignore unavailable or malformed session storage. */ }
    return null;
  }

  function unavailable() {
    const container = document.getElementById('cart-page-vat-form');
    if (container) container.textContent = 'Btw-formulier is niet beschikbaar. Vernieuw de pagina om het opnieuw te proberen.';
  }

  function mount() {
    const container = document.getElementById('cart-page-vat-form');
    if (!container || !window.SufioVAT || current?.container === container) return;
    if (current && current.container.dataset.customerEmail === container.dataset.customerEmail) {
      // Keep the SDK's listeners and an in-flight request across a footer render.
      container.replaceWith(current.container);
      return;
    }
    current?.observer.disconnect();
    container.replaceChildren();
    // These are documented Sufio options; do not call its internal store/API.
    window.SufioVAT.onCart({ selectors: '#cart-page-vat-form', alwaysVisible: true, saveButtonEnabled: true });
    const email = container.querySelector('input[type="email"]');
    const vat = container.querySelector('input[type="text"]');
    const save = container.querySelector('.sufio-vat-save-button');
    const status = container.querySelector('.sufio-vat-number-status');
    if (!email || !vat || !save || !status) return unavailable();

    for (const [input, id, placeholder] of [[email, 'Cart-vat-email', 'naam@bedrijf.nl'], [vat, 'Cart-vat-number', 'BE0123456789']]) {
      input.id = id;
      input.placeholder = placeholder;
      input.required = true;
      input.classList.remove('field__input');
      input.parentElement.classList.remove('field');
      const label = input.parentElement.querySelector('label');
      label.htmlFor = id;
      label.classList.remove('field__label');
      input.before(label);
      label.after(document.createTextNode('\n          '));
    }
    vat.parentElement.querySelector('label').textContent = 'Btw-nummer';
    const customerEmail = container.dataset.customerEmail;
    // A logged-in customer must validate against their own account email.
    email.readOnly = !!customerEmail;
    save.classList.remove('button');
    status.classList.remove('form__message');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    container.querySelector('.sufio-vat-email-status')?.remove();
    const actions = document.createElement('div');
    actions.className = 'cart-summary__vat-actions';
    const cancel = document.createElement('button');
    cancel.type = 'button';
    cancel.textContent = 'Annuleren';
    actions.append(save, document.createTextNode('\n            '), cancel);
    container.append(actions, status);
    // Sufio normally collapses its fields after Save; this panel stays expanded.
    let accepted = null;
    let pending = false;
    let lastSubmission = 0;
    const pair = () => ({ email: email.value, vat: vat.value });
    const matches = (a, b) => !!a && a.email === b.email && a.vat === b.vat;
    const message = (text) => { status.textContent = text; status.style.display = text ? '' : 'none'; };
    const inputEvent = (input) => input.dispatchEvent(new Event('input', { bubbles: true }));
    const sync = () => {
      // Each Sufio input event can redraw both fields from its internal state.
      const values = pair();
      email.value = values.email;
      inputEvent(email);
      vat.value = values.vat;
      inputEvent(vat);
    };
    const resetPair = { email: customerEmail || '', vat: '' };
    const saved = restore(customerEmail);
    if (saved) {
      email.value = saved.email;
      vat.value = saved.vat;
      sync();
      message('Controleer en sla je btw-nummer opnieuw op voordat je afrekent.');
    }

    function lock(busy) {
      pending = busy;
      container.setAttribute('aria-busy', String(busy));
      email.readOnly = busy || !!customerEmail;
      vat.readOnly = busy;
      cancel.disabled = busy;
    }

    // Observe Sufio's own result and disabled state, rather than recreating requests.
    const observer = new MutationObserver(() => {
      const result = status.textContent;
      if (!pending || save.disabled || !result || result === 'Btw-nummer controleren...') return;
      lock(false);
      if (status.textContent === 'Btw-nummer gecontroleerd en opgeslagen voor btw-vrijstelling.') {
        accepted = pair();
        remember(accepted);
      }
    });
    observer.observe(container, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });

    save.addEventListener('click', (event) => {
      if (pending) { event.stopImmediatePropagation(); return; }
      email.value = email.value.trim();
      vat.value = vat.value.trim().replace(/\s+/g, '').toUpperCase();
      sync();
      if (!email.checkValidity() || !vat.checkValidity()) {
        event.stopImmediatePropagation();
        message(!email.value ? 'Vul je e-mailadres in.' : !email.validity.valid ? 'Vul een geldig e-mailadres in.' : 'Vul je btw-nummer in.');
        (!email.validity.valid ? email : vat).reportValidity();
        return;
      }
      // Sufio throttles requests for one second; do not leave a second pair busy.
      if (Date.now() - lastSubmission < 1100) {
        event.stopImmediatePropagation();
        message('Wacht even voordat je het opnieuw probeert.');
        return;
      }
      lastSubmission = Date.now();
      message('Btw-nummer controleren...');
      lock(true);
    }, true);

    cancel.addEventListener('click', () => {
      if (pending) return;
      const previous = accepted || resetPair;
      email.value = previous.email;
      vat.value = previous.vat;
      sync();
      // Sufio does not remove an empty VAT attribute/query parameter itself.
      if (!previous.vat) {
        document.querySelectorAll('form[action*="/cart"]').forEach((form) => {
          form.querySelector('input[name="attributes[VAT Registration Number]"]')?.remove();
          if (!customerEmail) {
            const url = new URL(form.action, location.href);
            url.searchParams.delete('checkout[email]');
            form.action = url.pathname + url.search;
          }
        });
        remember(null);
      }
      message('');
    });

    current = { container, observer, refreshForm() {
      const text = status.textContent;
      sync();
      message(text);
    }, guard(event) {
      if (!vat.value && (!email.value || email.value === customerEmail) && !pending) return;
      if (!pending && matches(accepted, pair())) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!pending) message('Sla je btw-nummer op of annuleer voordat je afrekent.');
      save.focus();
    } };
  }

  // Capture before delegated wholesale handlers; do not replace checkout navigation.
  document.addEventListener('click', (event) => {
    if (event.target.closest('#checkout, .cart__dynamic-checkout-buttons')) current?.guard(event);
  }, true);
  document.addEventListener('submit', (event) => {
    if (event.target.id === 'cart' && event.submitter?.name === 'checkout') current?.guard(event);
  }, true);
  document.addEventListener('shopify:section:load', mount);
  let cartForm;
  new MutationObserver(() => {
    if (window.SufioVAT) mount();
    const nextForm = document.getElementById('cart');
    if (nextForm !== cartForm) {
      cartForm = nextForm;
      current?.refreshForm();
    }
  }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  window.SlimCartVAT = { mount, unavailable };
})();
